import type { components } from "./schema";
import { json, request } from "./client";

export type ConnectRequestView = components["schemas"]["ConnectRequestView"];

export const oauthApi = {
  view: (blob: string) =>
    request<ConnectRequestView>(`/api/oauth/request?request=${encodeURIComponent(blob)}`),
  decide: (blob: string, allow: boolean) =>
    request<{ redirect_url: string }>(
      "/api/oauth/decision",
      json("POST", { request: blob, allow }),
    ),
};

/** Only the Allow page may be a return destination (mirrors the server's safe_next_path). */
export function safeReturnPath(value: string | null): string | null {
  return value && value.startsWith("/oauth/consent?") ? value : null;
}
